import { useLocation, useNavigate, useParams } from "react-router-dom";
import SideModal from "@/common/components/CustomModal/SideModal";
import ModalTitleHeader from "@/common/components/ModalTitleHeader";
import routes from "@/common/routes";
import Language from "@/common/utils/language/en";
import { useAppSelector } from "@/common/hooks";
import NigerianForm from "./NigerianForm";
import OtherForms from "./OtherForms";

const { FundBankForm: PageDictionary } =
  Language.protected.walletModals.funding;

function FundBankForm() {
  const { appid } = useParams();
  const navigate = useNavigate();
  const currency = useAppSelector(
    (state) => state.wallet.exchange_rate.data?.fund_rate.to,
  );
  const location = useLocation().state?.background;

  const handleBackDrop = () => {
    if (!appid) return;
    navigate(
      location?.pathname ??
        routes.protected.applications.app.wallet.link(appid),
      {
        replace: true,
      },
    );
  };

  return (
    <SideModal
      onclickBackDrop={handleBackDrop}
      className="p-8 md:pt-22 md:pl-15 md:pr-28"
    >
      <ModalTitleHeader
        title={PageDictionary.header.title}
        subtitle={PageDictionary.header.subtitle}
      />
      {currency === "NGN" || currency === "NGNL" ? (
        <NigerianForm />
      ) : (
        <OtherForms />
      )}
    </SideModal>
  );
}

export default FundBankForm;
